import {Pipe, PipeTransform} from "@angular/core";
/**
 * Pipe for formatting comms types created by karora on 13/06/17.
 */
@Pipe({name: 'commsType'})
export class CommsTypePipe implements PipeTransform {
  transform(value: number): string {
    switch(value) {
      case 50017:  return "Error";
      case 50018:  return "Info";
      case 50019:  return "Request";
      case 50020:  return "Response";
    }
    return ""+value;
  }
}
